import { getRemoteConfig, Value } from "firebase/remote-config";

import React, { useContext } from "react";

import { firebaseApp } from "../firebaseApp";

export const FirebaseRemoteConfigContext = React.createContext<
  { [key: string]: string | number | boolean | Value } | undefined
>(undefined);

export const remoteConfig = getRemoteConfig(firebaseApp);

export const useFirebaseRemoteConfig = () => {
  const context = useContext(FirebaseRemoteConfigContext);
  if (context === undefined) {
    throw new Error(
      "useFirebaseRemoteConfig must be within FirebaseRemoteConfigContextProvider",
    );
  }

  return context;
};
